import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './imageCarousel.css';

class ImageCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      items: [],
      currentItem: '',
      isNext: true,
    };
    this.__handleAutoplay = null;
  }
  
  __getIndex = (searchedItem, items) => {
    return items.findIndex(item => item === searchedItem);
  }
  
  handlePrev = () => {
    let { items, currentItem } = this.state;
    let index = this.__getIndex(currentItem, items);
    if(index < 1) {
      index = items.length;
    }
    currentItem = items[index - 1];
    const isNext = false;
    this.setState({ currentItem, isNext });
  }
  
  handleNext = () => {
    let { items, currentItem } = this.state;
    let index = this.__getIndex(currentItem, items);
    if(index === items.length - 1) {
      index = -1;
    }
    currentItem = items[index + 1];
    const isNext = true;
    this.setState({ currentItem, isNext });
  }
  
  handleSeek = (requestedItem, currentItem) => {
    const { items } = this.state;
    let currentIndex = this.__getIndex(currentItem, items);
    const requestedIndex = this.__getIndex(requestedItem, items);
    currentItem = requestedItem;
    const isNext = (currentIndex < requestedIndex);
    this.setState({ currentItem, isNext });                 
  }

  enableAutoplay = (t) => {
    this.__handleAutoplay = setTimeout(() => {
      this.handleNext();
      this.enableAutoplay(t);
    }, t);
  }

  disableAutoplay = () => {
    clearTimeout(this.__handleAutoplay);
    this.__handleAutoplay = null;
  }
  
  componentDidMount() {
    const { data, autoplay } = this.props;
    let { items } = this.state;
    data.forEach((e) => {
      items.push(e.src);
    });
    const currentItem = items[0];
    this.setState({ data, items, currentItem });
    if(autoplay) this.enableAutoplay(autoplay);
  }
  
  render(){
    const { autoplay } = this.props;
    const { data, items, currentItem, isNext } = this.state;
    const index = items ? this.__getIndex(currentItem, items) : 0;
    const caption = data[index] ? data[index].caption : '';
    const backgroundImage = `url(${currentItem})`;
    const isSelectDisabled = Boolean(window.innerWidth / data.length < 60);
    const controlsOnMouseEnter = () => this.disableAutoplay();
    const controlsOnMouseLeave = () => this.enableAutoplay(autoplay);
    return (
      <div
        className="carousel"
      >
        <ReactCSSTransitionGroup
          transitionName={{
            enter: isNext ? 'enter-next' : 'enter-prev',
            enterActive: 'enter--active',
            leave: 'leave',
            leaveActive: isNext ? 'leave-next--active' : 'leave-prev--active'
          }}
        >
          <div
            className="carousel__slide"
            key={index}
            style={{ backgroundImage }}
            data-caption={caption}
          ></div>
        </ReactCSSTransitionGroup>
        <button
          className="carousel__control carousel__control__prev"
          onClick={this.handlePrev}
          onMouseEnter={controlsOnMouseEnter}
          onMouseLeave={controlsOnMouseLeave}
        ><span></span></button>
        <button
          className="carousel__control carousel__control__next"
          onClick={this.handleNext}
          onMouseEnter={controlsOnMouseEnter}
          onMouseLeave={controlsOnMouseLeave}
        ><span></span></button>
        <CarouselSelect
          items={items}
          currentItem={currentItem}
          selectHandler={this.handleSeek}
          mouseEnterHandler={controlsOnMouseEnter}
          mouseLeaveHandler={controlsOnMouseLeave}
          disabled={isSelectDisabled}
        />
      </div>
    )
  }
}

const CarouselSelect = (props) => {
  const {
    items,
    currentItem,
    selectHandler,
    mouseEnterHandler,
    mouseLeaveHandler,
    disabled
  } = props;
  const clsOuter = `carousel__select ${disabled ? 'disabled' : ''}`;
  const slides = items.map((item, index) => {
    const clsInner = (item === currentItem) ? 'active' : '';
    return(
      <li key={index}>
        <button
          className={clsInner}
          onClick={() => selectHandler(item, currentItem)}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
        ></button>
      </li>
    );
  });
  return <div className={clsOuter}><ul>{slides}</ul></div>;
}

export default ImageCarousel;
